module.exports = __webpack_public_path__ + "img/three1Orange.41d0341e.png";